import { Typography, styled } from '@mui/material';

const Title = styled(Typography)({
  fontSize: '2rem',
  lineHeight: 1.25,
  marginBottom: '1.5rem',
});

export default Title;
